import React from "react"

export const FailModalGrooveTicket = ({
  failModalClass,
  setButtonLoading,
  closeFailModal,
  segment,
  targetInbox,
}) => {
  const clickhandler = () => {
    setButtonLoading()
    closeFailModal()
  }

  return (
    <div className={`modal ${failModalClass}`}>
      <div
        className="modal-background"
        onClick={clickhandler}
        role="button"
        tabIndex="-1"
        onKeyDown={() => {}}
        aria-label="Close Fail Modal"
      ></div>
      <div className="modal-content">
        <div className="box" style={{ maxWidth: 800, margin: "0 auto" }}>
          <p className="title is-4 mb-2"> Irgendetwas ist schief gelaufen...</p>
          <hr className="is-mitternachtsblau-30 my-3" />

          <p>Leider ist Ihre Anfrage fehlgeschlagen.</p>
          <p>
            Bitte versuchen Sie es erneut, oder{" "}
            <b>schreiben Sie eine E-Mail an:</b>
          </p>
          <p className="mb-5">
            <a href={`mailto:${targetInbox}`}>{targetInbox}</a>
          </p>
          <div className="mt-4">
            <button
              className="button is-sonnengelb ml-auto"
              aria-label="delete"
              onClick={clickhandler}
            >
              <b>Schließen</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
